const formatCommas = value => {
  if (!value) return ""
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

const parseFormat = value => {
  if (!value) return ""
  return value.replace(/\₫|\s|,/g, "")
}

export { parseFormat, formatCommas }

